import React from 'react';
import PackageImage from 'Assets/Icons/PackageFamilyImageForHomePage.png';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSelector } from 'react-redux';
import UnifitLogo from 'Assets/Icons/PackageImages/unifit.png';
import { getFormattedDays, slugify } from 'Utils/Functions';

const PopularPackage = ({ data, heading, showViewAll }) => {
  const { loading } = useSelector((state) => state.loader);
  let { cityName } = useSelector((state) => state.location);
  
  cityName = slugify(cityName);

  const settings = {
    arrows: data?.length > 4 ? true : false,
    dots: data?.length > 4 ? true : false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    lazyLoad: true,
    infinite: false,
    draggable: false,

    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 410,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  };

  const navigation = useNavigate();

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-heading">
            <h2>{heading ? heading : 'Popular Health Packages'}</h2>
            {showViewAll && (
              <Link
                className={`viewall-btn ${
                  data?.length <= 4 && 'remove-margin-left'
                }`}
                to={`/${cityName}/health-packages?popular-packages=true`}
              >
                View All
              </Link>
            )}
          </div>
        </div>

        <div className="col-12">
          {data?.length > 0 ? (
            <Slider
              {...settings}
              className="popular-health-content"
            >
              {data?.map((item, index) => (
                <div
                  onClick={() =>
                    navigation(
                      `/${cityName}/health-packages/${item?.service_slug}`
                    )
                  }
                  className="package-card"
                  key={item?.service_id}
                >
                  {item?.discount_percentage !== 0 && (
                    <div className="price-tag">
                      <span>{Math.floor(item?.discount_percentage)}% off</span>
                    </div>
                  )}
                  <div className="">
                    {item?.is_unifit && (
                      <div className="unifit-logo">
                        <img
                          src={UnifitLogo}
                          alt=""
                        />
                      </div>
                    )}
                    <figure className="package-card-image">
                      <img
                        src={
                          item?.service_image
                            ? item.service_image
                            : PackageImage
                        }
                        alt={PackageImage}
                      />
                    </figure>

                    <div className="package-card-content">
                      <h3 className="ellipsis-two-lines">
                        {item?.service_name}
                      </h3>
                      {item?.bookings && (
                        <div className="available-date">
                          <span>Available on </span>
                          {getFormattedDays(item?.bookings)}
                        </div>
                      )}
                      <p>{item?.no_of_test_include} Tests included</p>
                      <div className="package-card-footer">
                        <div className="price">
                          <em className="price-icon-orange-big">₹</em>
                          {item?.total_amount}
                          {item?.mrp_amount !== item?.total_amount && (
                            <span>
                              <em className="price-icon-grey-small">₹</em>
                              {item?.mrp_amount ?? 0}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            !loading && <h3 className="text-center">No Data Found</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopularPackage;
